import {Genome} from 'constants/GenomeConstants';
import AppDispatcher from 'lib/Dispatcher';
import Store from 'lib/Store';

class GenomeStore extends Store {
  genomes!: Array<Genome>;

  override resetState(): void {
    this.genomes = window?.bootstrap?.genomes ?? [];
  }

  getGenomes(): Array<Genome> {
    return this.genomes;
  }

  override payloadHandler(): boolean {
    return true;
  }
}

export default new GenomeStore(AppDispatcher);
